/**
 * The two facts behind "how many case report forms are approved", as pure
 * functions, so every reader counts the same way.
 *
 * The Study Documents hub, the Study Build page and useCrfApproval all read the
 * same two stores: the CRF Builder's working session (`crfBuilder/session`,
 * field `forms`) and the `crf` artifacts that approval writes. Each one used to
 * spell out the status rule and the "no forms array" rule itself.
 */

/** A crf artifact counts as approved when its status is approved or final. */
export function isApprovedCrfStatus(status: unknown): boolean {
  return status === 'approved' || status === 'final';
}

/** Forms in the CRF Builder's session document; a missing document or field is zero forms. */
export function sessionFormCountOf(data: { forms?: unknown } | null | undefined): number {
  const forms = data?.forms;
  return Array.isArray(forms) ? forms.length : 0;
}
